import MIMESA_LABELS from './labels';
import MIMESA_FEATURES from './features';
import MIMESA_NAVIGATION from './navigation';
import MIMESA_ACCESS from './access';
import MIMESA_CONFIG from './config';

/**
 * Mimesa: its own backend (PostgreSQL, mimesa/service), served from this admin with the same
 * login. This is the light half of the registration (no page components), read by the
 * company registry, the session and the access model; `./index.js` adds the pages.
 */
const MIMESA = Object.freeze({
    id: 'mimesa',
    name: 'Mimesa',
    workspaceLabel: 'Mimesa',
    defaultApiUrl: 'https://mimesaservice.shelfve.com',
    // Local development against a local Mimesa service.
    apiUrlOverride: process.env.REACT_APP_MIMESA_API_URL,
    adminUserTypes: Object.freeze(['admin', 'gerente', 'asesor', 'client']),
    userTypes: Object.freeze(['gerente', 'asesor', 'promotor', 'location', 'admin', 'client', 'route']),
    labels: MIMESA_LABELS,
    features: MIMESA_FEATURES,
    navigation: MIMESA_NAVIGATION,
    access: MIMESA_ACCESS,
    config: MIMESA_CONFIG,
});

export default MIMESA;
